import { useQueryClient } from 'react-query';
import { createQueryData } from '../helpers/createQueryData';
import { useEvent } from '../../../../hooks/useEvent';

const endPoint = 'Acceptance/report_summary_data';

const { createKey, fn } = createQueryData({
  endPoint,
  options: {
    errorMessage: 'Не удалось загрузить статистику по приемке',
  },
});

export const useFetchReportSummaryData = () => {
  const queryClient = useQueryClient();

  return useEvent(({ acceptanceId, houseId }, options) => {
    const params = { acceptanceId, houseId };
    return queryClient.fetchQuery(createKey(params), () => fn(params), options);
  });
};
